module.exports = __webpack_public_path__ + "img/medical_affiliation.52f157d4.png";